module.exports = __webpack_public_path__ + "static/media/Wayne Mayo_1585002071501.dce3f912.jpeg";